'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bus = new _vue2.default();

exports.default = bus;


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/bus.js
// module id = jlkA
// module chunks = 0